import { getRegisterName } from '@/utils/form';

export const STATS_USAGE_REGISTER_NAME = getRegisterName([
  'DATE_PICKER_TYPE',
  'START',
  'END',
  'COMPANY_NAME',
  'SVC_NAME',
  'ID_TYPE',
  'FILTER_ID',
  'PRODUCT_IDS'
]);
